/* eslint-disable react/jsx-curly-spacing */
/* eslint-disable template-curly-spacing */
import React, { Component } from 'react';
import Club from './Club';
import KegiatanKelompok from './KegiatanKelompok';

export default class managementProlanis extends Component {
  render() {
    return (
      <div className="m-4">
        <div className='row'>
          <div className='col-12'>
            <Club />
          </div>
          <div className='col-12'>
            <KegiatanKelompok />
          </div>
        </div>
      </div>
    );
  }
}
